<template>
  <div class="manage-notes">
    <label @click="$router.push('/admin/home')" class="back">
      <figure>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </figure>
      <p>Gerenciar notas</p>
    </label>

    <label class="search" for="search-note">
      <input autocomplete="off" type="text" placeholder="Digite o titulo da nota para buscar" id="search-note" v-model="filter.search" @keydown.enter="getNotes()">
      <svg v-if="!filter.search" @click="getNotes()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else @click="filter.search = ''; getNotes();" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M4 4L16 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 4L4 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </label>

    <TransitionGroup tag="div" name="note-card" class="notes-grid" v-if="notes && notes.length">
      <div
        class="note-card"
        v-for="note in notes"
        :key="note.id"
      >
        <div class="card-top">
          <h2>{{ note.title }}</h2>
        </div>
        <div class="card-bottom">
          <p class="card-description">{{ stripHtml(note.description) }}</p>
          <div class="card-footer">
            <button class="open-btn" @click="openNote(note)">abrir nota</button>
            <div class="card-icons">
              <button @click="$router.push({ name: 'admin.notes.edit', params: { id: note.id } })">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path fill="none" d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button @click="isConfirmDeleteModal = true; noteToDeleteId = note.id">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path fill="none" d="M21 5.98C17.67 5.65 14.32 5.48 10.98 5.48C9 5.48 7.02 5.58 5.04 5.78L3 5.98M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97M18.85 9.14L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 19.21L5.15 9.14M10.33 16.5H13.66M9.5 12.5H14.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </TransitionGroup>

    <div class="no-options" v-else-if="notes && !notes.length">
      <svg xmlns="http://www.w3.org/2000/svg" width="173" height="173" viewBox="0 0 24 24" fill="none">
        <path opacity="0.4" d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 13H15" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 16H12.5" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 6H14C15 6 15 5 15 4C15 2 14.5 2 14 2H10C9.5 2 9 2 9 4C9 6 9.5 6 10 6Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <h1>Sem notas para gerenciar no momento</h1>
      <p><a @click="$router.push('/admin/create-notes')">Clique aqui</a> para cadastrar</p>
    </div>
    <SpinnerLoader v-else />

    <MyModal :width="'620px !important'" :height="'560px !important'" :isOpen="isDetailModalOpen" :class-name="'note-detail-modal'" :toggleModal="(v: boolean) => isDetailModalOpen = v" :zIndex="100">
      <div class="note-detail">
        <h1>Detalhes da nota</h1>
        <div class="note-detail__content" v-html="selectedNote?.description"></div>
      </div>
    </MyModal>

    <MyModal :width="'330px !important'" :height="'260px !important'" :isOpen="isConfirmDeleteModal" :class-name="'confirm-delete'" :toggleModal="(v: boolean) => isConfirmDeleteModal = v" :zIndex="100">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
          <path d="M42.2722 12.6747L29.4021 5.24301C27.3005 4.02967 24.7005 4.02967 22.5771 5.24301L9.72881 12.6747C7.62715 13.888 6.32715 16.1413 6.32715 18.5897V33.4097C6.32715 35.8363 7.62715 38.0897 9.72881 39.3247L22.5988 46.7563C24.7005 47.9697 27.3005 47.9697 29.4238 46.7563L42.2938 39.3247C44.3955 38.1113 45.6955 35.858 45.6955 33.4097V18.5897C45.6738 16.1413 44.3738 13.9097 42.2722 12.6747ZM24.3755 16.7913C24.3755 15.903 25.1121 15.1663 26.0005 15.1663C26.8888 15.1663 27.6255 15.903 27.6255 16.7913V28.1663C27.6255 29.0547 26.8888 29.7913 26.0005 29.7913C25.1121 29.7913 24.3755 29.0547 24.3755 28.1663V16.7913ZM27.9938 36.0313C27.8855 36.2913 27.7338 36.5297 27.5388 36.7463C27.1271 37.158 26.5855 37.3747 26.0005 37.3747C25.7188 37.3747 25.4371 37.3097 25.1771 37.2013C24.8955 37.093 24.6788 36.9413 24.4621 36.7463C24.2671 36.5297 24.1155 36.2913 23.9855 36.0313C23.8771 35.7713 23.8338 35.4897 23.8338 35.208C23.8338 34.6447 24.0505 34.0813 24.4621 33.6697C24.6788 33.4747 24.8955 33.323 25.1771 33.2147C25.9788 32.868 26.9321 33.063 27.5388 33.6697C27.7338 33.8863 27.8855 34.103 27.9938 34.3847C28.1021 34.6447 28.1671 34.9263 28.1671 35.208C28.1671 35.4897 28.1021 35.7713 27.9938 36.0313Z" fill="#A30711"/>
        </svg>
        <h1>Cuidado!</h1>
        <h2>Deseja mesmo remover essa nota?</h2>
        <section>
          <button @click="isConfirmDeleteModal = false; deleteNote(noteToDeleteId)">Sim</button>
          <input @click="isConfirmDeleteModal = false" type="button" value="Cancelar">
        </section>
      </div>
    </MyModal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import NoteModel from '@/models/NoteModel'
import NoteStatusEnum from '@/enums/NoteStatusEnum'
import { AxiosResponse } from 'axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import MyModal from '@/components/modal/MyModal.vue'

const axios = useAxios()
const notes = ref<NoteModel[]>()
const filter = ref<Record<string, string>>({ status: NoteStatusEnum.ACTIVE })
const isConfirmDeleteModal = ref(false)
const noteToDeleteId = ref(0)
const isDetailModalOpen = ref(false)
const selectedNote = ref<NoteModel | null>(null)

function stripHtml (html: string | null): string {
  if (!html) return ''
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

function openNote (note: NoteModel): void {
  selectedNote.value = note
  isDetailModalOpen.value = true
}

function getNotes (): void {
  notes.value = undefined
  const params: Record<string, string> = {}
  if (filter.value.search) params.search = filter.value.search

  axios.get('/api/notes', { params })
    .then((res: AxiosResponse<NoteModel[]>) => {
      notes.value = res.data
    })
}

function deleteNote (id: number): void {
  notes.value = notes.value?.filter(n => n.id !== id)
  const notesValue = notes.value
  notes.value = undefined

  const formData = new FormData()
  formData.append('note_ids[]', String(id))

  axios.delete('/api/notes', formData)
    .then(() => {
      notes.value = notesValue
    })
    .catch(() => getNotes())
}

onMounted(() => {
  getNotes()
})
</script>

<style lang="scss">
  .manage-notes {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 32px 0 60px 0;

    .search {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      margin: 0 0 40px 0;

      input {
        width: 100%;
        height: 55px;
        border: none;
        border-radius: 16px;
        background: #F5F5F5;
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 500;
        padding: 20px 56px 20px 20px;
        box-sizing: border-box;
        transition: background .2s;

        &:focus {
          outline: none;
          &::placeholder { color: transparent; }
        }
        &::placeholder {
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-weight: 500;
        }
      }
      svg {
        width: 20px;
        min-width: 20px;
        height: 20px;
        position: absolute;
        right: 20px;
        stroke: #090909;
        cursor: pointer;
      }
    }

    .note-card-leave-active {
      transition: opacity .3s ease, transform .3s ease;
    }
    .note-card-leave-to {
      opacity: 0;
      transform: scale(0.82);
    }

    .notes-grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      box-sizing: border-box;

      .note-card {
        display: flex;
        flex-direction: column;
        border-radius: 18px;
        border: 1.5px solid #EBEBEB;
        background: #FFF;
        box-sizing: border-box;
        min-height: 175px;
        overflow: hidden;
        transition: background .25s, border-color .25s;
        animation: enterContent ease-in-out .5s;
        cursor: default;

        .card-description {
          color: #000000 !important;
        }

        &:hover {
          border-color: #5B35C8;

          .card-bottom {
            background: #5B35C8;
            p { color: rgba(255, 255, 255, 0.82); }

            .card-description {
              color: #fff !important;
            }
            .card-footer {
              .open-btn {
                background: #FFF;
                color: #5B35C8;
                &:hover { background: rgba(255, 255, 255, 0.92); }
              }

              .card-icons button svg { stroke: rgba(255, 255, 255, 0.82); }
              .card-icons button:hover svg { stroke: #FFF; }
            }
          }
        }

        .card-top {
          padding: 20px 20px 16px 20px;

          h2 {
            color: #0D0D0D;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 700;
            margin: 0;
            line-height: 1.45;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-align: start;
            transition: color .25s;
          }
        }

        .card-bottom {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: #F1F1F1;
          padding: 14px 20px 18px 20px;
          transition: background .25s;

          p {
            color: #737373;
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-weight: 400;
            margin: 0 0 14px 0;
            line-height: 1.6;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-align: start;
            transition: color .25s;
          }

          .card-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .open-btn {
              height: 34px;
              padding: 0 16px;
              border-radius: 30px;
              background: #D3D3D3;
              color: #A2A2A2;
              font-family: 'Inter', sans-serif;
              font-size: 13px;
              font-weight: 500;
              cursor: pointer;
              border: none;
              transition: background .25s, color .25s;
              white-space: nowrap;
            }

            .card-icons {
              display: flex;
              align-items: center;
              gap: 8px;

              button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 26px;
                height: 26px;
                cursor: pointer;
                background: none;
                border: none;
                padding: 0;

                svg {
                  width: 19px;
                  height: 19px;
                  stroke: #000;
                  fill: none;
                  transition: stroke .2s;
                }

                &:hover svg { stroke: #3A3A3A; }
              }
            }
          }
        }
      }
    }

    .no-options {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 80px 0;
      gap: 16px;

      svg { opacity: 0.3; }

      h1 {
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 18px;
        font-weight: 600;
        margin: 0;
      }

      p {
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 400;
        margin: 0;

        a {
          color: $fluxoo-primary-color;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    .modal {
      &.note-detail-modal {
        .modal__content {
          padding: 0;
          overflow: hidden;
        }

        .note-detail {
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: 36px 36px 32px 36px;
          box-sizing: border-box;

          h1 {
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 22px;
            font-weight: 700;
            margin: 0 0 24px 0;
            text-align: start;
            flex-shrink: 0;
          }

          &__content {
            flex: 1;
            overflow-y: auto;
            color: #292929;
            font-family: 'Inter', sans-serif;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.7;
            text-align: start;
            padding-right: 8px;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-track {
              background: #F5F5F5;
              border-radius: 4px;
            }
            &::-webkit-scrollbar-thumb {
              background: #D5D5D5;
              border-radius: 4px;
            }

            p, ul, ol { margin: 0 0 10px 0; }
            ul, ol { padding-left: 20px; }
            li { margin-bottom: 6px; }
            strong { font-weight: 600; }
          }
        }

        button.close-modal {
          display: flex !important;
          top: 28px;
          right: 28px;
        }
      }

      &.confirm-delete {
        div div {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 26px 15px 24px;

          h1 {
            color: #090909;
            font-family: 'Nunito', sans-serif;
            font-size: 28px;
            font-weight: 900;
            margin: 2px 0 7px 0;
          }
          h2 {
            color: #6F6F6F;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 400;
            margin: 0;
          }
          section {
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            padding: 0;
            margin: 33px 0 0 0;

            button {
              height: 30px;
              width: 80px;
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 18px;
              font-weight: 500;
              display: flex;
              justify-content: center;
              align-items: center;
              transition: color .2s;
              cursor: pointer;
              &:hover { color: $fluxoo-primary-color; }
            }
            input {
              height: 60px;
              border-radius: 30px;
              background: #090909;
              color: #FFF;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-weight: 500;
              border: none;
              width: 173px;
              cursor: pointer;
            }
          }
        }
        button.close-modal { display: flex !important; top: 28px; right: 28px; }
      }
    }
  }

  @media(max-width: 1100px) {
    .manage-notes .notes-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media(max-width: 768px) {
    .manage-notes .notes-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media(max-width: 480px) {
    .manage-notes .notes-grid {
      grid-template-columns: 1fr;
    }

    .manage-notes .modal.note-detail-modal .note-detail {
      padding: 28px 20px 24px 20px;
    }
  }
</style>
